export default {
  en: {
    chart: 'Line chart',
  },
};
